import React from "react";
import Grid from "@material-ui/core/Grid";
import Skeleton from "@material-ui/lab/Skeleton";
import Text from "@origyn-sa/common-ui/src/components/atoms/Text";

const NFTItemContent = () => (
  <Grid container spacing={4}>
    <Grid item xs={12} sm={5} lg={4}>
      <Skeleton variant="rect" height={300} width="100%" />
      <>
        <Skeleton variant="text" />
        <br />
        <Skeleton variant="text" />
        <Skeleton variant="text" />
        <Skeleton variant="text" />
      </>
      <Text spacing={1} color="primary">
        <Skeleton variant="text" />
      </Text>
    </Grid>
    <Grid item xs={12} sm={7} lg={8}>
      <Skeleton variant="rect" width={300} height={50} />
      <Text spacing={0.5}>
        <Skeleton variant="text" width={150} />
      </Text>
      <Text spacing={0.5}>
        <Skeleton variant="text" width={150} />
      </Text>
      <Text spacing={0.5}>
        <Skeleton variant="rect" height={47} width={205} />
      </Text>
      <Text spacing={3}>
        <Skeleton variant="rect" height={300} width="100%" />
      </Text>
    </Grid>
  </Grid>
);

export default NFTItemContent;
